/**
 * @generated SignedSource<<24ee73541c0bcd033c3ce65f98a34a39>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type TaskStatus = "ABORTED" | "COMPLETED" | "CREATED" | "EXECUTING" | "FAILED" | "PAUSED" | "SCHEDULED" | "SKIPPED" | "TRIGGERED" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type TaskDurationChip_task$data = {
  readonly creationTimestamp: number;
  readonly durationInSeconds: number;
  readonly executingTimestamp: number | null;
  readonly id: string;
  readonly scheduledTimestamp: number | null;
  readonly status: TaskStatus;
  readonly " $fragmentType": "TaskDurationChip_task";
};
export type TaskDurationChip_task$key = {
  readonly " $data"?: TaskDurationChip_task$data;
  readonly " $fragmentSpreads": FragmentRefs<"TaskDurationChip_task">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TaskDurationChip_task",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "creationTimestamp",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "scheduledTimestamp",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "executingTimestamp",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "durationInSeconds",
      "storageKey": null
    }
  ],
  "type": "Task",
  "abstractKey": null
};

(node as any).hash = "bae676cb4747739330afb57a18dca0eb";

export default node;
